// extracted by mini-css-extract-plugin
module.exports = {"main-content":"AppLayout_main-content__1B95T"};